export default __webpack_public_path__ + "static/media/0026.6f371621.jpg";